import { RecommendationOptions } from '../../../types';

export interface DetailsTableRow {
  key: string;
  rowHeader: string;
  [RecommendationOptions.YOUR_ENTRY]: string | number;
  [RecommendationOptions.FVSS_RECOMMENDATION]: string | number;
}


export type ChartDataSet = {
  plantingRate: number;
  yield: number;
}

export enum xDataKey {
  PLANTING_RATE = 'plantingRate',
}

export type ChartDataSets = Array<ChartDataSet>;

export type DropdownState = {
  name: string | null;
  id: string | null;
}; 
